var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":"mini","type":"primary","icon":"el-icon-s-order"},on:{"click":function($event){return _vm.$refs.fileinput.click()}}},[_vm._v("\n  Prova\n  "),_c('input',{ref:"fileinput",staticClass:"d-none",attrs:{"type":"file"},on:{"change":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }